import React from 'react';
import {
    main,
    ewaAdam01,
    ewaAdam02,
    ewaAdam03,
    ewaAdam04,
    ewaAdam05,
    ewaAdam06,
    ewaAdam07,
    ewaAdam08,
    ewaAdam09,
    ewaAdam10,
    ewaAdam11,
    ewaAdam12,
    ewaAdam13,
    ewaAdam14,
    ewaAdam15,
    ewaAdam16,
    ewaAdam17,
    ewaAdam18,
    ewaAdam19,
    ewaAdam20,
    ewaAdam21,
    ewaAdam22,
    ewaAdam23,
    ewaAdam24,
    ewaAdam25,
    ewaAdam26,
    ewaAdam27,
    ewaAdam30,
    ewaAdam31,
    ewaAdam32,
    ewaAdam33,
    ewaAdam34,
    ewaAdam35,
    ewaAdam36,
    ewaAdam37,
    ewaAdam38,
    ewaAdam39,
    ewaAdam40,
    ewaAdam41,
    ewaAdam42,
    ewaAdam43,
    ewaAdam44,
    ewaAdam45,
    ewaAdam46,
    ewaAdam47,
    ewaAdam48,
    ewaAdam49,
    ewaAdam50,
} from '../OurCouplesPics/EwaAdam';

export const EwaAndAdam = {
    bgColor: "bgPink",
    title: "Ewa i Adam – kolorowy slow wedding w Folwarku Ruchenka",
    path: "kolorowy-slow-wedding-w-folwarku-ruchenka",
    minHeight: true,
    seoTitle: "Ewa i Adam – kolorowy slow wedding w Folwarku Ruchenka",
    seoText: "Pełne słońca, kolorów i radości wesele w duchu slow wedding. Ewa i Adam postawili na luz, naturę i autentyczność – zamiast przepychu wybrali wspólne chwile, taniec na trawie i świętowanie miłości w otoczeniu bliskich.",
    mainPic: {
        src: main
    },
    details: "Pełne słońca, kolorów i radości wesele w duchu slow wedding. Ewa i Adam postawili na luz, naturę i autentyczność – zamiast przepychu wybrali wspólne chwile, taniec na trawie i świętowanie miłości w otoczeniu bliskich. Ceremonia w ogrodzie i dekoracje ze słonecznikami nadały temu dniu niezwykłego ciepła.",
    org: "Agencja Ślubna Czary Marry",
    orgLink: "",
    place: "Folwark Ruchenka",
    placeLink: "",
    date: "22 gru 2025",
    textMain:
        <>
            <p>Z Ewą i Adamem spotkałyśmy się w momencie, kiedy zaczynali myśleć o swoim ślubie, ale wiedzieli, że przy ich tempie życia nie chcą robić tego sami. Pracują dużo i w nieregularnych godzinach, więc potrzebowali kogoś, kto przeprowadzi ich przez cały proces spokojnie i z wyczuciem. Chcieli, by ich dzień był lekki, pełen emocji i autentyczności – dopracowany, ale bez presji. Dlatego zaprosili nas do współpracy, powierzając nam organizację, by mogli przeżyć przygotowania bez pośpiechu i z radością.</p>
            <p>Od pierwszych rozmów wiedziałyśmy, że ślub Ewy i Adama będzie miał zupełnie inny rytm. Zamiast formalnego przyjęcia marzyli o dniu spontanicznym, radosnym i pełnym autentyczności – o wydarzeniu, które po prostu będzie "ich".</p>
        </>,
    topPic: { src: main },
    content: [
        {
            headerSmall: 'Folwark Ruchenka – miejsce z duszą',
            headerClassName: "pink",
            text: <>
                <p>Folwark Ruchenka to wyjątkowa przestrzeń położona niedaleko Warszawy – stodoła z charakterem, w której historia spotyka się z naturą. Wysokie belki, drewno, miękkie światło i otaczająca zieleń tworzą atmosferę swobody i spokoju. To właśnie tam Ewa i Adam poczuli, że znaleźli miejsce, które odzwierciedla ich styl – naturalny, radosny i bliski temu, co prawdziwe.</p>
                <p>Wszystko – od przygotowań, przez ceremonię, aż po wesele – odbyło się w jednym miejscu, co idealnie wpisało się w ideę slow wedding.</p></>,
            pics: [
                { src: ewaAdam01 },
                { src: ewaAdam02 },
                { src: ewaAdam03 },
                { src: ewaAdam04 },
                { src: ewaAdam05 },
            ]
        },
        {
            headerSmall: "Stylizacja i przygotowania – kolor, emocje i swoboda",
            headerClassName: "pink",
            text: <>
                <p>
                    Poranek w Folwarku Ruchenka upłynął w ciepłej, radosnej atmosferze. Ewa przygotowywała się w otoczeniu bliskich – z mamą, świadkową i przyjaciółkami. W powietrzu unosił się zapach świeżych kwiatów, a w tle grała spokojna muzyka. Było dużo śmiechu, wzruszeń i tej wyjątkowej ekscytacji, którą czuje się tylko w dniu ślubu.
                </p>
                <p>Ewa wyglądała olśniewająco – w delikatnej, romantycznej sukni o subtelnym połysku, która pięknie poruszała się w świetle dnia. Jej bukiet był prawdziwym manifestem koloru: pełen energetycznych odcieni pomarańczy, brzoskwini i różu, z sezonowych kwiatów i drobnych detali, które dodawały całości charakteru. Luźny welon, naturalny makijaż i uśmiech sprawiły, że wyglądała lekko, świeżo i w pełni sobą.</p>
                <p>Adam spędzał poranek w sąsiednim budynku Folwarku – w męskim gronie świadków i przyjaciół. Tam również panowała swobodna atmosfera: rozmowy, żarty, wspólne poprawianie much i detali stroju. Jego stylizacja idealnie współgrała z klimatem dnia – klasyczna, ale z nutą luzu, dopasowana do ciepłych barw i rustykalnego charakteru miejsca.</p>
                <p>Para nie widziała się przez cały poranek. Spotkali się dopiero przed ołtarzem – w chwili, która na długo zapadła wszystkim w pamięć. Wzruszenie, spojrzenie pełne emocji i ciche „to już teraz” – to był moment, w którym cały świat na chwilę się zatrzymał.</p>
            </>,
            pics: [
                { src: ewaAdam06 },
                { src: ewaAdam07 },
                { src: ewaAdam08 },
                { src: ewaAdam09 },
                { src: ewaAdam10 },
                { src: ewaAdam11 },
                { src: ewaAdam12 },
                { src: ewaAdam13 },
                { src: ewaAdam14 },
                { src: ewaAdam15 },
                { src: ewaAdam16 },
                { src: ewaAdam17 },
                { src: ewaAdam18 },
            ]
        },
        {
            headerSmall: "Ceremonia humanistyczna w Folwarku – wśród natury i emocji",
            headerClassName: "pink",
            text: <>
                <p>Ceremonia Ewy i Adama odbyła się w ogrodzie Folwarku Ruchenka, tuż przed salą weselną. Przestrzeń została pięknie przygotowana – wśród zieleni stanął kwiatowy łuk w ciepłych odcieniach pomarańczy, różu i złamanej żółci. Naturalne światło i subtelne dekoracje stworzyły tło, które nie potrzebowało żadnych dodatków, by zachwycać.</p>
                <p>To właśnie tutaj Para zobaczyła się po raz pierwszy tego dnia. Adama do ołtarza prowadziła mama, a Ewę – tata. Ten moment był pełen emocji – wzruszenia, czułości i radości, której nie da się opisać słowami.</p>
                <p>Ewa i Adam zdecydowali się na ślub humanistyczny. Od początku wiedzieli, że chcą, by ceremonia była prawdziwa, osobista i dokładnie taka, jak oni – szczera i ciepła. Dlatego bardzo starannie wybierali celebranta, szukając osoby, której energia i sposób bycia będą współgrały z ich charakterami. To była dobra decyzja – ceremonia była niezwykle poruszająca, pełna autentycznych emocji, śmiechu i łez. Ich przysięgi wzruszyły niemal każdego – od najbliższych po tych, którzy poznali ich dopiero tego dnia.</p>
            </>,
            pics: [
                { src: ewaAdam19 },
                { src: ewaAdam20 },
                { src: ewaAdam21 },
                { src: ewaAdam22 },
                { src: ewaAdam23 },
                { src: ewaAdam24 },
                { src: ewaAdam25 },
                { src: ewaAdam26 },
                { src: ewaAdam27 },
            ]
        },
        {
            headerSmall: "Natura, kolory i słoneczniki – dekoracje w barwach Ewy i Adama",
            headerClassName: "pink",
            text: <>
                <p>Wnętrze Folwarku Ruchenka samo w sobie ma niezwykły klimat – ciepłe drewno, wysokie belki i miękkie światło wpadające przez okna. Ten naturalny charakter stał się idealnym tłem dla kolorowej, energetycznej aranżacji, którą wspólnie z florystką Aldoną stworzyłyśmy tak, aby jak najlepiej oddawała osobowość Ewy i Adama.</p>
                <p>Na stołach pojawiły się kompozycje z sezonowych kwiatów: róż ogrodowych, dalii, cynii, lwiej paszczy, kosmosów i kopru – w odcieniach pomarańczy, brzoskwini, różu i złamanej czerwieni. Całość dopełniała zieleń i drobne łąkowe akcenty, które nadawały lekkości. Kluczową rolę odegrały <span className='pink bold'>słoneczniki</span> – ulubione kwiaty Ewy, które często dostaje od Adama. To właśnie one stały się symbolem tego dnia – radosnym, ciepłym i pełnym światła.</p>
                <p>Nad stołami zawisły kompozycje z kwiatów i zieleni, przypominające odwróconą łąkę. Wiszące rośliny subtelnie poruszały się w powietrzu, tworząc naturalną ramę dla stołów i dodając przestrzeni miękkości. Na długich, drewnianych stołach znalazły się żółte bieżniki, pomarańczowe serwety i papeteria od <span className='pink bold'>Borda Zaprasza</span>, która idealnie wpasowała się w stylistykę – prosta, nowoczesna, a jednocześnie pełna ciepła.</p>
                <p>Przy wejściu do stodoły gości witała <span className='pink bold'>duża, pomarańczowa tablica z planem stołów</span>, ozdobiona kwiatami i zielenią. Ten efektowny akcent pięknie dopełniał całość, wprowadzając w klimat wnętrza już od pierwszego kroku. Dzięki przemyślanej kompozycji kolorów i naturalnych detali Folwark Ruchenka wypełnił się światłem i radością – dokładnie tak, jak marzyli Ewa i Adam.</p>
            </>,
            pics: [
                { src: ewaAdam37 },
                { src: ewaAdam30 },
                { src: ewaAdam31 },
                { src: ewaAdam32 },
                { src: ewaAdam33 },
                { src: ewaAdam34 },
                { src: ewaAdam35 },
                { src: ewaAdam36 },
            ]
        },
        {
            headerSmall: "Wesele w rytmie radości",
            headerClassName: "pink",
            text: <>
                <p>
                    Po ceremonii ogród Folwarku Ruchenka wypełnił się dźwiękami, śmiechem i rozmowami. W powietrzu czuć było luz, szczęście i tę wyjątkową energię, gdy emocje po ślubie spotykają się z radością wspólnego świętowania. Goście powoli przenieśli się do stodoły, gdzie czekała na nich kolorowa, pełna życia przestrzeń – idealna na długą, letnią noc.</p>
                <p>
                    Jedną z największych niespodzianek dla gości był <span className='pink bold'>zespół bałkański</span>, który towarzyszył im już podczas ceremonii, a później rozkręcił pierwsze chwile wesela. Ich muzyka niosła się po całym folwarku – żywiołowa, rytmiczna, pełna emocji – zachęcając do tańca, śmiechu i wspólnego przeżywania każdej chwili.</p>
                <p>
                    Wieczór płynął powoli, w rytmie rozmów, tańców i spontanicznych toastów. Był czas na zabawę, ale też na chwilę oddechu w ogrodzie, przy dźwiękach muzyki w tle. Wesele Ewy i Adama miało w sobie wszystko, co najpiękniejsze w idei slow wedding – swobodę, autentyczność i prawdziwą bliskość ludzi, którzy tego dnia przyszli po prostu celebrować miłość.
                </p>
            </>,
            pics: [
                { src: ewaAdam38 },
                { src: ewaAdam39 },
                { src: ewaAdam40 },
                { src: ewaAdam41 },
                { src: ewaAdam42 },
                { src: ewaAdam43 },
                { src: ewaAdam44 },
                { src: ewaAdam45 },
                { src: ewaAdam46 },
            ]
        },
        {
            headerSmall: "Nasza rola",
            headerClassName: "pink",
            text: "Dla nas, zespołu Czary Marry, to była realizacja pełna koloru, emocji i wdzięczności. Towarzyszyłyśmy Ewie i Adamowi od pierwszych pomysłów aż po ostatni taniec – wspierając ich, planując każdy szczegół i dbając, by wszystko przebiegało w ich tempie i na ich zasadach. To jeden z tych dni, które przypominają nam, dlaczego kochamy naszą pracę – bo możemy pomagać tworzyć chwile prawdziwe, szczere i pełne miłości.",
            pics: [
                { src: ewaAdam47 },
                { src: ewaAdam48 },
                { src: ewaAdam49 },
                { src: ewaAdam50 }]
        },
    ],
}